module.exports = __webpack_public_path__ + "img/bp13.7ceb3118.jpeg";